<template>
  <div class="product-aside-description" v-html="product.descriptionHtml"/>
</template>

<script>
export default {
  props: {
    product: Object
  }
};
</script>
